<mat-chip-set>
  <mat-chip disabled [class]="ChipModeEnum[mode()]">
    @if (icon()) {
      <mat-icon>{{ icon() }}</mat-icon>
    }
    <ng-content></ng-content>
  </mat-chip>
</mat-chip-set>
